import { useEffect, useState } from "react";
import { Star, Quote } from "lucide-react";
import api from "@/lib/api";
import { SectionHeading } from "@/components/Section";

export default function TestimonialsPage() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/testimonials").then((r) => setItems(r.data)).catch(() => {}); }, []);
  return (
    <div className="section-lux grid-glow">
      <div className="container-lux">
        <SectionHeading label="Testimonials" title="What Our Clients Say" subtitle="Real, approved feedback from businesses we work with." />
        {items.length === 0 ? (
          <div className="mt-14 max-w-lg mx-auto card-lux p-10 text-center" data-testid="testimonials-empty">
            <Quote className="mx-auto text-amber-400/60 mb-4" size={36} />
            <p className="text-slate-400">Client testimonials will appear here once published from the Admin Panel.</p>
          </div>
        ) : (
          <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {items.map((tm, i) => (
              <div key={tm.id} className="card-lux p-6 fade-up" style={{ animationDelay: `${i * 60}ms` }} data-testid={`testimonial-${tm.id}`}>
                <div className="flex gap-0.5 mb-3">
                  {Array.from({ length: 5 }).map((_, j) => (
                    <Star key={j} size={15} className={j < (tm.rating || 5) ? "text-amber-400 fill-amber-400" : "text-slate-600"} />
                  ))}
                </div>
                <p className="text-slate-300 leading-relaxed text-sm">"{tm.text}"</p>
                <div className="mt-5 flex items-center gap-3">
                  {tm.photo && <img src={tm.photo} alt={tm.name} className="h-10 w-10 rounded-full object-cover" />}
                  <div>
                    <div className="font-semibold text-white text-sm">{tm.name}</div>
                    <div className="text-xs text-slate-500">{[tm.company, tm.country].filter(Boolean).join(" · ")}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
